module.exports = __webpack_public_path__ + "media/components/src/assets/images/heading/heading_2-526d3c6e877b3232dff0e4e4c09fa968.png";